import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  Injectable,
  InjectionToken,
  Injector,
  Type,
  inject,
} from '@angular/core';

export const POPOVER_DATA = new InjectionToken<unknown>('POPOVER_DATA');

export interface PopoverConfig {
  content: Type<unknown>;
  data?: unknown;
}

@Injectable({ providedIn: 'root' })
export class PopoverService {
  /**
   * The services.
   */
  private overlay = inject(Overlay);
  private injector = inject(Injector);

  /**
   * Overlay ref.
   */
  private overlayRef: OverlayRef | null = null;

  /**
   * Open the popopver
   */
  open(anchor: HTMLElement, config: PopoverConfig) {
    this.close();
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(anchor)
      .withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
          offsetY: 8,
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
          offsetY: -8,
        },
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
    });

    const portal = new ComponentPortal(
      config.content,
      null,
      this.createInjector(config)
    );

    this.overlayRef.attach(portal);
    this.overlayRef.backdropClick().subscribe(() => this.close());
  }

  /**
   * Close the popover.
   */
  close(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  /**
   * Helper to create popover component injector.
   */
  private createInjector(config: PopoverConfig): Injector {
    return Injector.create({
      parent: this.injector,
      providers: [{ provide: POPOVER_DATA, useValue: config.data }],
    });
  }
}
